import React, { useState, useMemo, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import logo from "../../assets/images/fempulseLogo.png";
import "../../assets/css/Header.css";

const Header = ({ actions }) => {
  const [logoError, setLogoError] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const token = typeof window !== "undefined" ? localStorage.getItem("token") : null;
  const hasToken = !!token;

  const userInfo = useMemo(() => {
    if (!token) return { name: "User", email: "" };
    try {
      const decoded = jwtDecode(token);
      return {
        name: decoded?.name || decoded?.sub || "User",
        email: decoded?.email || ""
      };
    } catch (e) {
      return { name: "User", email: "" };
    }
  }, [token]);

  const userName = userInfo.name;
  const userEmail = userInfo.email;

  const navigateHome = () => {
    navigate("/home");
    setMenuOpen(false);
  };

  const handleLogout = () => {
    try {
      localStorage.removeItem("token");
    } catch (_) { }
    navigate("/login", { replace: true });
  };

  return (
    <header className="nav">
      {/* Logo */}
      <div className="brand">
        {!logoError ? (
          <img
            src={logo}
            alt="FEMPULSE Logo"
            onClick={navigateHome}
            onError={() => setLogoError(true)}
          />
        ) : (
          <div className="fallback-logo" onClick={navigateHome}>
            FEMPULSE
          </div>
        )}
      </div>

      {/* Desktop-only actions */}
      <div className="actions desktop-only">
        {actions}
        {hasToken && (
          <div className="profile-dropdown-container" ref={dropdownRef}>
            <div 
              className="profile-trigger" 
              onClick={() => setDropdownOpen(!dropdownOpen)}
            >
              <div className="user-avatar">
                {userName ? userName.charAt(0).toUpperCase() : "U"}
              </div>
              <span style={{color: '#007bff'}} className="header-user-email">
                {userEmail}
              </span>
              <span className={`chevron ${dropdownOpen ? 'open' : ''}`}>▼</span>
            </div>

            {dropdownOpen && (
              <div className="profile-dropdown-menu">
                <div className="dropdown-user-details">
                  <div className="dropdown-name">{userName}</div>
                  <div className="dropdown-email">{userEmail}</div>
                </div>
                <div className="dropdown-divider" />
                <button
                  className="dropdown-logout-btn"
                  onClick={handleLogout}
                >
                  Logout
                </button>
              </div>
            )}
          </div>
        )}
      </div>

      {/* Mobile hamburger */}
      <div
        className={`hamburger mobile-only ${menuOpen ? "open" : ""}`}
        onClick={() => setMenuOpen(!menuOpen)}
      >
        <span></span>
        <span></span>
        <span></span>
      </div>

      {/* Mobile slide menu */}
      <div className={`mobile-menu ${menuOpen ? "show" : ""}`}>
        {hasToken && (
          <div className="mobile-user-info">
            <div className="user-avatar" style={{ marginBottom: '15px' }}>
              {userName ? userName.charAt(0).toUpperCase() : "U"}
            </div>
            <div className="mobile-user-label">Signed in as</div>
            <div className="mobile-user-name">{userName}</div>
          </div>
        )}
        {actions}
        {hasToken && (
          <button
            className="button secondary"
            onClick={handleLogout}
            style={{ backgroundColor: '#d32f2f', color: '#fff', borderColor: '#d32f2f' }}
          >
            Logout
          </button>
        )}
      </div>
    </header>
  );
};

export default Header;